import { DeleteIcon, ResetIcon } from '@clubspark-react/ui';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

import useStyles from './style';

type Props = {
  error: string;
  value: string;
  handleChange: (value: string) => void;
  handleDelete: () => void;
  handleReset: () => void;
  deleteOption: boolean;
  resetOption: boolean;
};

const InputWithActions = ({
  error = '',
  value,
  handleChange,
  handleDelete,
  deleteOption,
  resetOption,
  handleReset,
}: Props) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  return (
    <div className={classes.inputContainer}>
      <TextField
        fullWidth
        error={!!error}
        sx={{
          '& .MuiFormHelperText-root': {
            height: '19px',
          },
          '& .MuiInputBase-root': {
            height: '39px',
          },
          '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
              borderWidth: '1px',
              borderColor: '#d5d7de',
            },
            '&:hover fieldset': {
              borderColor: '#d5d7de',
            },

            '&.Mui-error fieldset': {
              borderColor: '#d42f42',
            },
          },
        }}
        value={value}
        onChange={(e) => handleChange(e.target.value)}
      />
      <span className={classes.error}>{error || ''}</span>

      {resetOption && (
        <button className={classes.button} onClick={handleReset}>
          <div>
            <ResetIcon />
          </div>
          <span>{t('reset')}</span>
        </button>
      )}
      {deleteOption && (
        <button className={classes.button} id="delete" onClick={handleDelete}>
          <div>
            <DeleteIcon />
          </div>
          <span className={classes.colorRed}>{t('delete')}</span>
        </button>
      )}
    </div>
  );
};
export default InputWithActions;
